import { colors } from '@globals/themes/defaultTheme'
import { AVATAR_SIZE } from './froalaMentionsUtils'

/** CSS injected once per page while mentions are enabled: chip colour and Tribute menu overrides. */
export const getFroalaMentionsStyles = (): string => `
  .fr-wrapper span[data-type="mention"] {
    color: ${colors.bluePrimary};
    font-weight: 600;
    gap: 4px;
  }
  /* Tribute.js mentions menu overrides */
  .tribute-container {
    box-shadow: rgba(90, 91, 102, 0.15) 0px 2px 8px 0px;
    border-radius: 16px;
    border-color: ${colors.grayExtraLight};
    border-width: 1px;
    border-style: solid;
  }
  .tribute-container ul {
    padding: 8px;
    background-color: ${colors.white} !important;
  }
  .tribute-container li {
    padding: 6px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-right: -8px;
    margin-left: -8px;
  }
  .tribute-container li.highlight {
    /* Style the highlighted/selected menu item */
    background-color: ${colors.blueExtraLight};
  }
  .tribute-menu-item {
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .tribute-menu-item-avatar {
    width: ${AVATAR_SIZE}px;
    height: ${AVATAR_SIZE}px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }
`
